export enum Categories {
  UIUX = 'uiux',
  ANIMATION = 'animation',
  GRAPHIC = 'graphic',
  ILLUSTRATION = 'illustration',
}

export interface PortfolioItem {
  id: string
  fields: {
    title: string
    description: {
      content: Array<{ content: { value: string } }>
    }
    coverImage: {
      fields: {
        file: {
          url: string
        }
      }
    }
    image?: {
      fields: {
        file: {
          url: string
        }
      }
    }
    video?: {
      fields: {
        file: {
          url: string
        }
      }
    }
    client: string
    website: string
    category: Array<Categories>
  }
}

export interface PortfolioItems {
  items: Array<PortfolioItem>
}
